import WCoveringDesktop from './WCoveringDesktop'

export default WCoveringDesktop
